import {
  makeAutoObservable,
  onBecomeObserved,
  onBecomeUnobserved,
  runInAction,
} from 'mobx';

const TICK_MS = 30000;

/**
 * An observable wall clock.
 *
 * Anything that renders "18min ago" needs one: a computed built on `Date.now()`
 * caches its first answer and then sits there lying, because nothing tells MobX
 * the clock moved. Read `Clock.now` instead and the value refreshes on its own.
 *
 * The interval runs only while something observes it.
 */
class ClockClass {
  private _now = Date.now();

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    let ticker: ReturnType<typeof setInterval> | null = null;

    onBecomeObserved(this, '_now', () => {
      runInAction(() => {
        this._now = Date.now();
      });
      ticker = setInterval(() => {
        runInAction(() => {
          this._now = Date.now();
        });
      }, TICK_MS);
    });

    onBecomeUnobserved(this, '_now', () => {
      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }
    });
  }

  get now(): number {
    return this._now;
  }

  /** Test seam: move the clock without waiting for a tick. */
  set(timestamp: number) {
    runInAction(() => {
      this._now = timestamp;
    });
  }
}

export const Clock = new ClockClass();
